export const SET_LATEST_COURSES = 'SET_LATEST_COURSES';
export const SET_POPULAR_COURSES = 'SET_POPULAR_COURSES';
export const SET_POPULAR_COLLECTIONS = 'SET_POPULAR_COLLECTIONS';
export const UPDATE_FETCHED_COURSES = 'UPDATE_FETCHED_COURSES';
export const UPDATE_COURSES_CONTENT = 'UPDATE_COURSES_CONTENT';
export const SET_COURSE_ASSESSMENT = 'SET_COURSE_ASSESSMENT';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';